import React from 'react';
import Button from 'commonComponents/Button/Button';
import styles from './Positions.module.scss';

const Positions = ({ title, button }) => (
  <section className={ styles.PositionsWrapper }>
    <div className={ styles.PositionsContent }>
      <div>
        <h1>{ title }</h1>
        <Button link="/jobs" label={ button } />
      </div>
    </div>
  </section>
);

export default Positions;
